<template>
  <b-form @submit="onSubmit">
    <b-form-group
      id="input-group-name"
      :label="$t('label.name')"
      label-for="input-name">
      <b-form-input
        id="input-name"
        v-model="form.serv_name"
        type="text"
        required
      />
    </b-form-group>
    <b-form-group
      id="input-group-perimeters"
      :label="$t('label.perimeter')"
      label-for="input-perimeters">
      <b-form-select
        id="input-perimeters"
        v-model="form.serv_peri_id"
        :options="perimeters"
        required
      />
    </b-form-group>
    <b-form-checkbox
      id="input-is_default"
      v-model="form.serv_is_default"
      :value="true"
      :unchecked-value="false"
      :disabled="!allowDefault && !service.serv_is_default"
      required>
      {{ $t("label.default") }}
    </b-form-checkbox>
    <b-form-checkbox
      id="input-is_enable"
      v-model="form.serv_is_enable"
      :value="true"
      :unchecked-value="false"
      required>
      {{ $t("label.active") }}
    </b-form-checkbox>
    <b-row>
      <b-col class="text-right">
        <b-button
          type="submit"
          variant="primary">{{ $t("btn.validate") }}</b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
export default {
  name: 'FormService',
  props: {
    service: {
      type: Object,
      default: null,
    },
    id: {
      type: Number,
      default: null,
    },
    allowDefault: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        serv_id: null,
        serv_name: null,
        serv_is_enable: true,
        serv_is_default: false,
        serv_peri_id: null,
      },
      perimeters: [],
    };
  },
  created() {

  },
  mounted() {
    this.$store.dispatch('establishments/getPerimeters', this.id)
      .then(response => this.mapPerimeters(response.data));
    this.form.serv_id = this.service.serv_id;
    this.form.serv_name = this.service.serv_name;
    this.form.serv_is_enable = this.service.serv_is_enable;
    this.form.serv_is_default = this.service.serv_is_default;
    this.form.serv_peri_id = this.service.serv_peri_id;
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();

      if (!this.allowDefault) {
        // Updated service can be default only if original service was already default
        this.form.serv_is_default = this.form.serv_is_default && this.service.serv_is_default;
      }

      this.$emit('sendForm', JSON.stringify(this.form));
    },
    mapPerimeters(data) {
      for (let i = 0; i < data.length; i += 1) {
        this.perimeters.push({ value: data[i].peri_id, text: data[i].peri_label });
      }
    },
  },
};
</script>

<style scoped>

</style>
